import React from 'react'
import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import './reports.css'
function Reports() {

    const navigate = useNavigate();
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                    <h3>Reports</h3>
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Reports</span>
                </Grid>
                <Grid size={{xs:12}} container alignItems="flex-start" className="my-3" style={{minHeight:"60vh"}}>
                    <Grid size={{md:3,sm:4}} container className="px-2">
                        <div onClick={()=>navigate("/reports/jobseeker")} className='main_reportgrids w-100 d-flex flex-column align-items-center'>
                            <img src={require('../../assets/sidebaricons/icon5.svg').default} alt=''/>
                            <span>Jobseeker Reports</span>
                        </div>
                    </Grid>
                    <Grid size={{md:3,sm:4}} container className="px-2">
                        <div onClick={()=>navigate("/reports/knowledge")} className='main_reportgrids w-100 d-flex flex-column align-items-center'>
                            <img src={require('../../assets/sidebaricons/icon3.svg').default} alt=''/>
                            <span>KBA Management Report</span>
                        </div>
                    </Grid>
                    <Grid size={{md:3,sm:4}} container className="px-2">
                        <div className='main_reportgrids w-100 d-flex flex-column align-items-center'>
                            <img src={require('../../assets/sidebaricons/icon13.svg').default} alt=''/>
                            <span>Community Member Report</span>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default Reports
